import { Component } from '@angular/core';
import { NavController, NavParams, AlertController } from 'ionic-angular';
import { CustomerDetails } from '../../interfaces';
import { HardcopyShippingAddressPage } from '../shipping-address/shipping-address';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import _ from 'lodash';
import { FirebaseAnalytics } from '@ionic-native/firebase-analytics';

@Component({
    selector: 'page-hardcopy-customer-details',
    templateUrl: 'customer-details.html'
})

export class HardcopyCustomerDetailsPage {

    public formGroup: FormGroup;

    public customerDetails: CustomerDetails = {
        name: '',
        email: ''
    };
    public editMode: boolean = false;
    public qty: number = 1;
    public saveCallback: (customerDetails: CustomerDetails) => void;

    constructor(
        public alertCtrl: AlertController,
        public analytics: FirebaseAnalytics,
        public formBuilder: FormBuilder,
        public navCtrl: NavController,
        public navParams: NavParams,
    ) {
        this.editMode = navParams.get('editMode');

        if (this.editMode) {
            this.customerDetails = Object.create(navParams.get('customerDetails'));
            this.saveCallback = navParams.get('saveCallback');
        }

        this.formGroup = this.formBuilder.group({
            name: ['', [Validators.required]],
            email: ['', [Validators.required, Validators.email]],
        });

        this.qty = this.navParams.get('qty');
    }

    public ionViewDidEnter() {
        this.analytics.setCurrentScreen('HardcopyCustomerDetails');
        this.analytics.logEvent('checkout_progress', {
            checkout_step: 2
        });
    }

    public next() {
        if (!this.formGroup.valid) return this.showValidationErrors();

        this.navCtrl.push(HardcopyShippingAddressPage, {
            customerDetails: this.customerDetails,
            qty: this.qty,
        });
    }

    public save() {
        if (!this.formGroup.valid) return this.showValidationErrors();

        if (this.saveCallback) this.saveCallback(this.customerDetails);

        this.navCtrl.pop();
    }

    public showValidationErrors() {
        _.forEach(this.formGroup.controls, control => {
            control.markAsDirty();
            control.markAsTouched();
        });

        let alert = this.alertCtrl.create({
            title: 'Something isn\'t right',
            message: 'Please check the information you have entered',
            buttons: [{
                text: 'OK',
            }]
        });

        alert.present();
    }

}



// WEBPACK FOOTER //
// ./src/pages/purchase-hardcopy/pages/customer-details/customer-details.ts